import React, { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { ManagerHomeScreen } from "../home/ManagerHomeScreen";
import { useDispatch, useSelector } from "react-redux";
import { selectUser } from "../../../store/selectors/UserSelector";
import { UserRole } from "../../../entity/User";
import { UnAuthorizedAccess } from "../../components/UnAuthorizedAccess";
import { StoreManagement } from "../stores/StoreManagement";
import { UsersManagement } from "../users/UsersManagment";
import { DeliveryManager } from "../delivery/DeliveryManager";
import { CollectionManager } from "../delivery/CollectionManager";
import { VRoutes } from "../../../navigation/Routes";
import { VParamsRoutes } from "../../../navigation/VParams";
import { AddCollectionToAction } from "../delivery/AddCollectionToAction";
import { PaymentManager } from "../payment/PaymentManager";
import { SupportByChatManagerScreen } from "../support/SupportByChatManagerScreen";
import { NotificationManager } from "../notification/NotificationManager";
import { MobileAppManager } from "../mobileApp/MobileAppManager";

const ManagerRoutes = () => {
  const user = useSelector(selectUser);
  const isAdmin =
    user?.role === UserRole.ADMIN || user?.role === UserRole.SUBADMIN;

  const dispatch = useDispatch();

  if (!isAdmin) {
    return <Navigate to="/unauthorized" replace />;
  }

  return (
    <Routes>
      <Route path={VRoutes.HOME} element={<ManagerHomeScreen />} />
      <Route path={VRoutes.STORES} element={<StoreManagement />} />
      <Route path={VRoutes.USERS} element={<UsersManagement />} />
      <Route path={VRoutes.UNAUTHORIZED} element={<UnAuthorizedAccess />} />
      <Route path={VRoutes.DELIVERY_MANAGER} element={<DeliveryManager />} />
      <Route
        path={VRoutes.DELIVERY_COLLECTIONS + ":" + VParamsRoutes.COMPANY_ID}
        element={<CollectionManager />}
      />
      <Route
        path={
          VRoutes.DELIVERY_ADD_COLLECTION_TO_ACTION +
          ":" +
          VParamsRoutes.COMPANY_ID
        }
        element={<AddCollectionToAction />}
      />
      <Route path={VRoutes.PAYMENT_MANAGER} element={<PaymentManager />} />
      <Route
        path={VRoutes.NOTIFICATION_MANAGER}
        element={<NotificationManager />}
      />
      <Route path={VRoutes.MOBILE_APP_MANAGER} element={<MobileAppManager />} />
      <Route
        path={VRoutes.SUPPORT_BY_CHAT_MANAGER}
        element={<SupportByChatManagerScreen />}
      />
    </Routes>
  );
};

export default ManagerRoutes;
